<div class="campaign-tabs">
  <div class="campaign-tabs--header x-extremes y-center">
    <div class="campaign-tab tab" *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
      <a>{{ tab.title }}</a>
    </div>
  </div>

  <ng-content></ng-content>
</div>
